/*******************************************************************************
 * Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          :  shipping-billing-actions.tsx
 *
 * Project Title :  Checkout
 *
 * Description    :
 *
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : Madhu Gali (H175591)
 *
 * @Date         : Aug 08, 2019
 *
 * @Version      : Version 1.0
 * *
 * By            : Madhu Gali
 * On            : Aug 08, 2019
 * Description   : ASDS-955: Shipping & Billing - Payment Info - PO - API integration
 *  *
 * By            : Avanthi G
 * On            : Aug 09, 2019
 * Description   : ASDS-956: Shipping & Billing - Added Payment Info values to store
 *
 * By            : Madhu Gali (H175591)
 * On            : Aug 23, 2019
 * Description   : ASDS-1089: Ability to add Email Functionality & Validations.
 *
 * By            : Madhu Gali (H175591)
 * On            : Sep 13, 2019
 * Description   : ASDS-1170: User email automatically populated.
 *
 * By            : Madhu Gali
 * On            : Sep 19 2019
 * Description   : ASDS-165
 *
 * By            	: Madhu Gali - H175591
 * On            	: Oct 04, 2019
 * Description      : ASDS-1476
 *
 *  By            	: sivateja.p (H267743)
 * On            	: Oct 10, 2019
 * Description      : added shipping and billing defaults and checkbox updates(ASDS-1296)
 *
 * By            	: Madhu Gali - H175591
 * On            	: Oct 04, 2019
 * Description   : ASDS-1476
 *
 * By            : SandeepRaja (E807238)
 * On            : Oct 17, 2019
 * Description   : ASDS-113: Configure and purchase 131-9 APU through PO
 *
 * By            : E807958
 * On            : 25 Nov 2019
 * Description   : ASDS-1676
 *
 * By            : H224423
 * On            : Dec 9, 2019
 * Description   : Removed shipping & billing checkbox
 *
 * By            : Deepthi Bachu(E844276)
 * On            : Jan 28, 2020
 * Description   : ASDS-2048 - Admin Functionality
 *
 * By            : Deepthi Bachu - E844276
 * On            : 11 Feb, 2020
 * Description   : ASDS-2197 - Select Account - Integrate Search by Type API Integration - New Changes
 *
 * By            : H422337
 * On            : Oct 08, 2020
 * Description   : ASDS - 3228 UI Enhancements for Phase - II
 *
 * By            : H422336
 * On            : Oct 14, 2020
 * Description   : ASDS - 3580 UI Enhancements for Phase - II
 *
 * By            : H422335
 * On            : Oct 27, 2020
 * Description   : ASDS-3269 Migration of backend URLs to Forge endpoints
 *
 * By            : H422337
 * On            : Oct,29 2020
 * Description   : ASDS-3576- UI Enhancements of phase-2 - Migrating to Forge API
 *
 * By            : H422335
 * On            : Oct 27, 2020
 * Description   : ASDS-3269 Migration of backend URLs to Forge endpoints
 ******************************************************************************/

import Action from '../actions/Action';
import CheckoutActionConstants from '../action-constants';
import { IAddEmailAddress } from '../../utils/checkout-interfaces';
import ShippingAndBillingAPI from '../../API/shipping-billing-api';
import { logError } from '../../../../utils/console-utility';
import CheckoutConstants from 'modules/checkout/constants/checkout-constants';

/**
 * @author H175591
 * @description This action class consists of all the actions
 * that deal with shipping and billing component.
 */
class ShippingBillingActions extends Action {

    /**
     * ASDS-955
     * @description: This method retrieves the customer CBD flag status.
     * @param {string} soldTo
     * @returns {(dispatch) => Promise<void>}
     */
    static getCustomerCBDStatus(soldTo: string) {
        return async (dispatch) => {
            await ShippingAndBillingAPI.getCustomerCBDStatusAPI(soldTo).then((response) => {
                dispatch(ShippingBillingActions.dispatchCBDStatusCall(response));
            }).catch(error => {
                logError('Error in processing getCustomerCBDStatus ', error);
            });
        };
    }

    static dispatchCBDStatusCall = (response) => {
        return {
            type: CheckoutActionConstants.GET_CUSTOMER_CBD_STATUS,
            payload: {
                response: response || null,
            }
        };
    }

    /**
     * ASDS-956
     * @description: This method stores the customer payment info to store.
     * @param {string} soldTo
     * @returns {(dispatch) => Promise<void>}
     */
    static setPaymentInfo(paymentInfo: any) {
        return (dispatch) => {
            dispatch({
                type: CheckoutActionConstants.SET_CUSTOMER_PAYMENT_INFO,
                payload: {
                    response: paymentInfo,
                }
            })
        };
    }

    static updateContractPurchaseDetails() {
        return (dispatch, getState) => {
            const productsInCart = getState().configAPUData.payload.productsInCart;
            let contractPurchaseData: any = [];
            productsInCart.forEach(product => {
                if(product.categoryName.toLowerCase() === CheckoutConstants.APU_CATEGORY_NAME){
                if (product.customerType.msa) {
                    product.customerType.apuMsaSerials.forEach(apuLineItem => {
                        if (apuLineItem.distributionNo) {
                            contractPurchaseData.push({
                                contractType: 'Contract',
                                contractNo: apuLineItem.distributionNo,
                                expirationDate: apuLineItem.expiryDate
                            });
                        }
                    });
                } else {
                    product.customerType.apuNonMsaSerials.forEach(apuLineItem => {
                        if (apuLineItem.distributionNo) {
                            contractPurchaseData.push({
                                contractType: apuLineItem.subProductDesc,
                                contractNo: apuLineItem.distributionNo,
                                expirationDate: apuLineItem.expiryDate
                            });
                        }
                    });
                }
            }
            });
            dispatch({
                type: CheckoutActionConstants.UPDATE_CONTRACT_PURCHASE_DATA,
                payload: {
                    response: contractPurchaseData,
                }
            });

        };
    }

    /**
     * ASDS-1089
     * @description: This method updates the email address in the store.
     * @param {string} soldTo
     * @returns {(dispatch, getState) => void}
     */
    static updateEmailAddress(emailAddress: string, index: number) {
        return (dispatch, getState) => {
            const addressObj: IAddEmailAddress[] = getState().shippingBillingData.payload.shippingBillingObj.emailAddress;
            const addressArr = [...addressObj];
            if (addressArr.length >= index) {
                addressArr[index].address = emailAddress;
            }
            dispatch({
                type: CheckoutActionConstants.ADD_UPDATE_EMAIL_ADDRESS,
                payload: {
                    response: {
                        emailAddress: addressArr,
                    }
                }
            });
        };
    }

    /**
     * ASDS-1089
     * @description: This method deletes the email address from store.
     * @param {number} index
     * @returns {(dispatch, getState) => void}
     */
    static deleteEmailAddress(index: number) {
        return (dispatch, getState) => {
            const addressObj: IAddEmailAddress[] = getState().shippingBillingData.payload.shippingBillingObj.emailAddress;
            const addressArr = [...addressObj];

            if (addressArr.length >= index) {
                addressArr.splice(index, 1);
            }

            const validations = [checkEmailIDFormat];
            const { validatedEmails, hasErrors } = validateEmailAddress(addressArr, validations);

            dispatch({
                type: CheckoutActionConstants.ADD_UPDATE_EMAIL_ADDRESS,
                payload: {
                    response: {
                        emailAddress: validatedEmails,
                        enableReviewOrderBtn: hasErrors,
                    }
                }
            });
        };
    }

    /**
     * ASDS-1089
     * @description: This method validates the email addresses added by the user.
     * @returns {(dispatch, getState) => void}
     */
    static validateInputContents() {
        return (dispatch, getState) => {
            const addressObj: IAddEmailAddress[] = getState().shippingBillingData.payload.shippingBillingObj.emailAddress;
            const validations = [checkEmailIDFormat];
            const { validatedEmails, hasErrors } = validateEmailAddress(addressObj, validations);
            dispatch(ShippingBillingActions.updateContractPurchaseDetails());
            dispatch({
                type: CheckoutActionConstants.ADD_UPDATE_EMAIL_ADDRESS,
                payload: {
                    response: {
                        emailAddress: validatedEmails,
                        enableReviewOrderBtn: hasErrors,
                    }
                }
            });
        };
    }

    /**
     * ASDS-1089
     * @description: This method add email address in the store.
     * @returns {(dispatch, getState) => void}
     */
    static addEmailAddress() {
        return (dispatch, getState) => {
            const emptyAddressObj = { address: '', error: '' };
            const previousAddressObj: IAddEmailAddress[] = getState().shippingBillingData.payload.shippingBillingObj.emailAddress;

            const validations = [checkEmailIDFormat];
            const validatedObj = validateEmailAddress(previousAddressObj, validations);
            const hasErrors: boolean = validatedObj.hasErrors;

            let addresses;
            if (hasErrors) {
                addresses = [...validatedObj.validatedEmails];
            } else {
                addresses = [...previousAddressObj, emptyAddressObj];
            }

            dispatch({
                type: CheckoutActionConstants.ADD_UPDATE_EMAIL_ADDRESS,
                payload: {
                    response: {
                        emailAddress: addresses,
                        enableReviewOrderBtn: hasErrors,
                    }
                }
            });
        };
    }

    /**
     * ASDS-1170
     * @description: This method add email address in the store which can be displayed in Shipping and Billing page.
     * @param email
     */
    static setLoggedInUserEmailAddress(email: string) {
        return (dispatch) => {
            const emailAddressArr = [{ address: '', error: '' }]
            const emptyAddressObj = emailAddressArr[0];
            emptyAddressObj.address = email;

            const hasErrors: boolean = false;
            dispatch({
                type: CheckoutActionConstants.ADD_UPDATE_EMAIL_ADDRESS,
                payload: {
                    response: {
                        emailAddress: emailAddressArr,
                        enableReviewOrderBtn: hasErrors,
                    }
                }
            });
        };
    }

    /**
     * ASDS-165
     * @description This method retrieves the paymetric stoken
     * @returns {(dispatch, getState) => void}
     */
    static updateCCPaymentData() {
        return (dispatch, getState) => {
            const accessToken: string = getState().paymetricData.payload.accessToken;
            const promise: any = ShippingAndBillingAPI.getCCPaymetricMetaData(accessToken);

            return promise.then(response => {
                dispatch({
                    type: CheckoutActionConstants.UPDATE_PAYMENT_MODE_CC_DATA,
                    payload: {
                        response: response.payment
                    },
                });
            });
        };
    }

    /**
     * ASDS-165
     * @description This toggles the display of loading while validating CC details.
     * @returns {(dispatch, getState) => Promise<void>}
     */
    static updateIsValidatingFlag() {
        return async (dispatch, getState) => {
            const isValidatingFlag: boolean = getState().shippingBillingData.payload.validationsFlag.isValidating;

            dispatch({
                type: CheckoutActionConstants.UPDATE_IS_VALIDATING_FLAG,
                payload: {
                    response: !isValidatingFlag,
                }
            });
        };
    }

    static updateCCPaymentFailure(isFailure: boolean) {
        return (dispatch) => {
            dispatch({
                type: CheckoutActionConstants.UPDATE_CC_PAYMENT_FAILURE,
                payload: {
                    creditCardPaymentFailure: isFailure
                }
            });
        };
    }

    static loadShippingBillingDefaults() {
        return async (dispatch, getState) => {
            let emailsFromSTore = getState().shippingBillingData.payload.shippingBillingObj.emailAddress;
            let emailAddress;
            /* scenario :
            *  1. Need to retain the EmailIds if user navigated back from Review order
            *  2. Need reset the emailIds if user Refreshes the page.
            * */
            if (emailsFromSTore && emailsFromSTore[0].address) {
                emailAddress = emailsFromSTore;
            } else {
                emailAddress = [{ address: getState().userValidationData.payload.userInfo.email, error: '' }];

            }
            dispatch({
                type: CheckoutActionConstants.GET_DEFAULT_EMAIL,
                payload: {
                    emailAddress: emailAddress
                }
            });
        };
    }

    /**
     * ASDS-1476
     * @description This idenntifies which payments tab the user is in and enalbes/ disables the Review Order button.
     */
    static identifyTabLevelError(activeTabIndex: number) {
        return (dispatch, getState) => {

            if (activeTabIndex === 0) {
                const isError = getState().paymetricData.isError;
                if (isError) {
                    dispatch(ShippingBillingActions.toggleEnableReviewOrderBtnStatus(true));
                }
            } else if (activeTabIndex === 1) {
                dispatch(ShippingBillingActions.toggleEnableReviewOrderBtnStatus(false));
            }
        };
    }

    /**
     * ASDS-1476
     * @description: Action creator for enable/ disable review order button
     * @param flag
     */
    static toggleEnableReviewOrderBtnStatus(flag) {
        return {
            type: CheckoutActionConstants.TOGGLE_ENABLE_REVIEW_ORDER_BTN,
            payload: {
                response: flag,
            }
        };
    }

    static setPaymentUpdateRequiredStatus(flag) {
        return {
            type: CheckoutActionConstants.UPDATE_PAYMENT_REQUIRED,
            payload: {
                paymentRequired: flag,
            }
        };
    }
}

/**
 * ASDS-1089
 * @description: This method consists of the validation logic of the entered email addresses.
 * @param {IAddEmailAddress[]} emailAddress
 * @param validations
 * @returns {{validatedEmails: any[]; hasErrors: boolean}}
 */
const validateEmailAddress = function (emailAddress: IAddEmailAddress[], validations: any) {
    const errorMsg = 'Email Address already added. Please enter a new Email Address.';
    const emailAddresses = emailAddress.map((obj) => {   // get array of serials
        return obj.address;
    });

    const validatedEmails = emailAddresses.map((email) => {
        const indexes = indexOfAll(emailAddresses, email);
        if (indexes.length > 1) {  // check of the duplicates, if found update the error msg.
            return { address: email, error: errorMsg };
        } else {                                    // if the element does not have any duplicates
            let errorMessage;
            for (let validation of validations) { // check other validations like required, onlyDigits..
                errorMessage = validation(email);
                if (errorMessage) {  // if error found break, no need to execute the other validation functions.
                    break;
                }
            }
            return { address: email, error: errorMessage };
        }
    });
    const errors = validatedEmails.filter((obj) => {
        return obj.error.length > 0;
    });
    const hasErrors = errors.length > 0;  // returns true if there is any error msg present in validated Emails array.
    return { validatedEmails: validatedEmails, hasErrors };
};

const checkEmailIDFormat = (emailID) => (/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(emailID))
    ? '' : 'Please enter valid email address. emailid@xxx.ext.ext is the correct format.; where xxx can be any domain name and ext is the extension(.com, .org, .in etc)';
const indexOfAll = (arr, val) => arr.reduce((acc, el, i) => (el === val ? [...acc, i] : acc), []);

export default ShippingBillingActions;
